var alignmentStyle = {"alignLeft":"R3diz","textWrapNowrap":"wtYCI","alignRight":"PZVO5","alignCenter":"wr0as","sizeFullWidth":"BxvtN","renderedInTable":"O43XM","sizeOriginal":"bLv2s","sizeContent":"ux-Qh","sizeSmall":"pZwd7","sizeSmallCenter":"gI6uj","flex":"tAQ3j","LEFT":"ChvS4","CENTER":"zc-Dj","RIGHT":"ktqNT","AUTO":"d33mg","JUSTIFY":"RsyXQ"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-b7de0bc6.js.map
